import {
    URLAPI,
    WORK_SUBPROCESS_RISK_CREATE_PATH,
    WORK_SUBPROCESS_RISK_UPDATE_PATH,
    WORK_SUBPROCESS_RISK_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _create_work_subprocess_risk: {
        data: {},
        status: 0,
        message: {},
    },
    _update_work_subprocess_risk: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_work_subprocess_risk: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_WORK_SUBPROCESS_RISK = "CREATE_WORK_SUBPROCESS_RISK";
export const UPDATE_WORK_SUBPROCESS_RISK = "UPDATE_WORK_SUBPROCESS_RISK";
export const DELETE_WORK_SUBPROCESS_RISK = "DELETE_WORK_SUBPROCESS_RISK";

export const work_subprocess_risks_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_WORK_SUBPROCESS_RISK:
            return {
                ...state,
                _create_work_subprocess_risk: action.payload,
            };
        case UPDATE_WORK_SUBPROCESS_RISK:
            return {
                ...state,
                _update_work_subprocess_risk: action.payload,
            };
        case DELETE_WORK_SUBPROCESS_RISK:
            return {
                ...state,
                _delete_work_subprocess_risk: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const createWorkSubprocessRisk = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_SUBPROCESS_RISK_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_SUBPROCESS_RISK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_SUBPROCESS_RISK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_SUBPROCESS_RISK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateWorkSubprocessRisk = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${WORK_SUBPROCESS_RISK_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_WORK_SUBPROCESS_RISK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_WORK_SUBPROCESS_RISK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_WORK_SUBPROCESS_RISK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteWorkSubprocessRisk = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${WORK_SUBPROCESS_RISK_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_WORK_SUBPROCESS_RISK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_WORK_SUBPROCESS_RISK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_WORK_SUBPROCESS_RISK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const clear_work_subprocess_risk = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
